<template>
    <div ref="scrollTarget"></div>
    <MainNav />

    <section class="laptop-section" style="margin-top: 50px; margin-bottom: 150px; padding-top: 65px">
        <div class="container" style="padding-top: 80px;">
            <div class="row">
                <div class="col-6 text-center">
                    <p style="text-align: left; padding-left: 45px; font-weight: 600; color: #CF0020; text-transform: uppercase; font-size: 1.3em;">
                        {{ translate('login_text1') }}
                    </p>
                    <p style="text-align: left; padding-left: 45px; font-weight: 600; color: #CF0020; font-size: 1.3em;">
                        {{ translate('login_text2') }}
                    </p>
                    <img src="../assets/img/login_image.jpg" style="margin-top: 15px;">
                </div>
                <div class="col-6 text-center">
                    <div class="border" style="border-radius: 15px; padding-top: 80px; padding-bottom: 80px; color: black; font-size: 1.3em;">
                        {{ translate('form_header') }}
                        <br>
                        <a class="btn btn-danger btn-connect" :href="nouvelEspaceUrl">{{ translate('login_new_space') }}</a>
                        <br>
                        <a v-if="montrerAncienEspace" class="btn btn-old-space" :href="log2xLoginUrl">{{ translate('login_old_space') }}</a>
                        <p v-if="montrerAncienEspace" class="login-hint">{{ translate('login_choose_hint') }}</p>
                        <br>
                        <p style="margin-top: 50px; font-weight: 600">{{ translate('not_yet_subscribed') }}</p>
                        <router-link to="/contact" style="margin-top: 30px;" class="btn btn-danger btn-connect">{{ translate('subscribe') }}</router-link>
                    </div>
                </div>
            </div>
        </div>  
    </section>

    <section class="ipad-section" style="margin-bottom: 150px; padding-top: 65px">
        <div class="container" style="padding-top: 80px;">
            <div class="row">
                <div class="col-12 text-center">
                    <p style="text-align: center; font-weight: 600; color: #CF0020; text-transform: uppercase; font-size: 1.3em;">
                        {{ translate('login_text1') }}
                    </p>
                    <p style="text-align: center; font-weight: 600; color: #CF0020; font-size: 1.3em;">
                        {{ translate('login_text2') }}
                    </p>
                    <img src="../assets/img/login_image.jpg" style="margin-top: 15px;">
                </div>
                <div class="col-12 text-center">
                    <div class="border" style="border-radius: 15px; padding-top: 80px; padding-bottom: 80px; color: black; font-size: 1.3em; margin-top: 20px;">
                        {{ translate('form_header') }}
                        <br>
                        <a class="btn btn-danger btn-connect" :href="nouvelEspaceUrl">{{ translate('login_new_space') }}</a>
                        <br>
                        <a v-if="montrerAncienEspace" class="btn btn-old-space" :href="log2xLoginUrl">{{ translate('login_old_space') }}</a>
                        <p v-if="montrerAncienEspace" class="login-hint">{{ translate('login_choose_hint') }}</p>
                        <br>
                        <p style="margin-top: 50px; font-weight: 600">{{ translate('not_yet_subscribed') }}</p>
                        <router-link to="/contact" style="margin-top: 30px;" class="btn btn-danger btn-connect">{{ translate('subscribe') }}</router-link>
                    </div>
                </div>
            </div>
        </div>  
    </section>

    <section class="mobile-section" style="margin-bottom: 150px; padding-top: 65px">
        <div class="container" style="padding-top: 80px;">
            <div class="row">
                <div class="col-12 text-center">
                    <p style="text-align: center; font-weight: 600; color: #CF0020; text-transform: uppercase; font-size: 1.3em;">
                        {{ translate('login_text1') }}
                    </p>
                    <p style="text-align: center; font-weight: 600; color: #CF0020; font-size: 1.3em;">
                        {{ translate('login_text2') }}
                    </p>
                    <img src="../assets/img/login_image.jpg" style="margin-top: 15px;">
                </div>
                <div class="col-12 text-center">
                    <div class="border" style="border-radius: 15px; padding-top: 80px; padding-bottom: 80px; color: black; font-size: 1.3em; margin-top: 20px;">
                        {{ translate('form_header') }}
                        <br>
                        <a class="btn btn-danger btn-connect" :href="nouvelEspaceUrl">{{ translate('login_new_space') }}</a>
                        <br>
                        <a v-if="montrerAncienEspace" class="btn btn-old-space" :href="log2xLoginUrl">{{ translate('login_old_space') }}</a>
                        <p v-if="montrerAncienEspace" class="login-hint">{{ translate('login_choose_hint') }}</p>
                        <br>
                        <p style="margin-top: 50px; font-weight: 600">{{ translate('not_yet_subscribed') }}</p>
                        <router-link to="/contact" style="margin-top: 30px;" class="btn btn-danger btn-connect">{{ translate('subscribe') }}</router-link>
                    </div>
                </div>
            </div>
        </div>  
    </section>

</template>


<script>
import axios from 'axios';
import MainNav from '@/components/MainNav2.vue';
import en from '@/en.js';
import fr from '@/fr.js';
import nl from '@/nl.js';

// La vitrine ne demande plus ni identifiant ni mot de passe : jusqu'au
// 23/09/2026 elle les écrivait dans l'adresse (WOPS_CIT?uname=…&upass=…),
// donc dans l'historique du navigateur et les journaux des serveurs.
// La page de connexion Log2X, elle, envoie le mot de passe hors de l'adresse.
const LOG2X_LOGIN_URL = 'https://www.citexpress.net/WOPS_CIT';

// Transition Log2X -> nouvel espace (décision du CEO du 03/11/2026) :
// « Se connecter » propose les deux espaces. Quand tous les clients sont
// passés, mettre MONTRER_ANCIEN_ESPACE à false : seul le nouvel espace reste.
const NOUVEL_ESPACE_URL = 'https://commande.citexpress.com/login';
const MONTRER_ANCIEN_ESPACE = true;

export default {
    mixins: [en, fr, nl],
    components: {
        MainNav
    },
    data() {
        return {
            lang: this.$store.state.lang,
            log2xLoginUrl: LOG2X_LOGIN_URL,
            nouvelEspaceUrl: NOUVEL_ESPACE_URL,
            montrerAncienEspace: MONTRER_ANCIEN_ESPACE
        }
    },
    computed: {
        lang2() {
            return this.$store.state.lang
        }
    },
    mounted() {
        document.title = 'CITExpress | Login';
        const element = this.$refs.scrollTarget;
        element.scrollIntoView({ behavior: 'smooth' });
    },
    methods: {
        translate(prop) {
            return this[this.lang2][prop];
        }
    }
}
</script>



<style>
.custom-input{
    border-radius: 8px;
    border: 1px solid #9B9B9B;
    background-color: #F5F5F5;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 300px;
}
.btn-connect{
    background-color: #CF0020;
    border-radius: 8px;
    border: none;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-top: 50px;
}
.btn-connect:hover{
    background-color: #940B20;
}
.btn-connect:focus{
    background-color: #940B20;
}
.btn-old-space{
    background-color: #FFFFFF;
    color: #CF0020;
    border: 2px solid #CF0020;
    border-radius: 8px;
    padding: 10px 20px;
    margin-top: 20px;
    font-size: 0.85em;
}
.btn-old-space:hover, .btn-old-space:focus{
    background-color: #FBE9EB;
    color: #940B20;
}
.login-hint{
    margin: 20px auto 0;
    max-width: 420px;
    font-size: 0.75em;
    line-height: 1.4;
    color: #333333;
}
</style>